// 全局vuex信息
// getter调用示例：this.$store.getters['test']

const state = {
  _test: 1
};

const getters = {
  test: (state) => state._test
};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
